export default __webpack_public_path__ + "static/media/regulatory--turning-vehicles-yield-to-pedestrians--g1.99692a47.png";